import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { styled as styling } from "@mui/material/styles";
import { Swiper } from "swiper/react";
import Color from "../../../assets/colors";

export const TitleStyled = styling(Typography)((props) => ({
  color: "rgba(0, 0, 0, 0.87)",
  fontSize: "40px",
  fontFamily: "Georgia",
  fontWeight: 400,
  lineHeight: "32px",
  textAlign: "center",

  span: {
    color: Color.hiredlyPurple,
    fontSize: "40px",
    lineHeight: "32px",
    fontWeight: 400,
  },

  ...(props?.type == "subtitle" && {
    color: "rgba(0, 0, 0, 0.60)",
    fontFamily: "Inter",
    fontSize: "20px",
    lineHeight: "24px",
    fontWeight: 500,
    textAlign: "center",
  }),

  [props.theme.breakpoints.down("lg")]: {
    fontSize: "32px",
    fontFamily: "Georgia",
    fontWeight: 400,
    lineHeight: "32px",
    textAlign: "center",

    span: {
      color: Color.hiredlyPurple,
      fontSize: "32px",
      lineHeight: "32px",
      fontWeight: 400,
    },

    ...(props?.type == "subtitle" && {
      fontFamily: "Inter",
      fontSize: "16px",
      lineHeight: "24px",
      fontWeight: 500,
      textAlign: "center",
    }),
  },

  [props.theme.breakpoints.down("tablet")]: {
    fontSize: "24px",
    fontFamily: "Georgia",
    fontWeight: 400,
    lineHeight: "32px",
    textAlign: "center",

    span: {
      color: Color.hiredlyPurple,
      fontSize: "24px",
      lineHeight: "32px",
      fontWeight: 400,
    },

    ...(props?.type == "subtitle" && {
      fontFamily: "Inter",
      fontSize: "12px",
      lineHeight: "24px",
      fontWeight: 500,
      textAlign: "center",
    }),
  },
}));

export const SwiperStyled = styling(Swiper)((props) => ({
  width: "100%",
  overflow: "hidden",

  "& .swiper-wrapper": {
    transitionTimingFunction: "linear",
  },

  "& .swiper-slide": {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "auto",
  },
}));

export const LogoContainer = styling(Grid)((props) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  height: "80px",
  padding: "12px",
  minWidth: "144px",

  cursor: "pointer",

  [props.theme.breakpoints.down("lg")]: {
    height: "70px",
    padding: "10px",
    minWidth: "120px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    height: "60px",
    padding: "8px",
    minWidth: "100px",
  },
}));

export const LogoStyled = styling("img")((props) => ({
  height: "100%",
  objectFit: "contain",
  maxWidth: "120px",
  maxHeight: "60px",
  backgroundSize: "contain",
  width: "100%",

  [props.theme.breakpoints.down("lg")]: {
    maxHeight: "50px",
    maxWidth: "100px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    maxHeight: "40px",
    maxWidth: "80px",
  },
}));

export const TitleContainer = styling(Grid)((props) => ({
  margin: "0px",

  [props.theme.breakpoints.down("tablet")]: {
    margin: "0px",
  },
}));

export const TrustedCompanyGrid = styling(Grid)((props) => ({
  padding: "80px 100px",
  gap: "30px",

  [props.theme.breakpoints.down("lg")]: {
    padding: "40px 24px",
    gap: "20px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    padding: "40px 16px",
    gap: "15px",
  },
}));

export const CarouselContainer = styling(Grid)((props) => ({
  // maxWidth: "1220px",
  // padding: "0px 200px",
  height: "100%",
  maxWidth: "1240px",

  [props.theme.breakpoints.down("lg")]: {
    // maxWidth: "720px",
    padding: "0px 0px",
  },

  // [props.theme.breakpoints.down("tablet")]: {
  //   maxWidth: "100%",
  // },
}));

export const CompanyButtons = styling("a")((props) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexShrink: 0,
  borderRadius: "16px",
  border: "1px solid #D8D8D8",
  background: "#F7F7FF",
  alignContent: "center",

  "&:hover": {
    border: "1px solid #512ACC",
  },

  [props.theme.breakpoints.down("lg")]: {},

  [props.theme.breakpoints.down("tablet")]: {},
}));

export const LandingBannerContainer = styling("div")((props) => ({
  width: "100%",
  display: "block",

  ...(!props.$imageOnly && {
    backgroundColor: "#050505",
    backgroundImage:
      "radial-gradient(ellipse at 15% 100%, rgba(76, 33, 207, 0.8) 0%, rgba(76, 33, 207, 0) 50%),radial-gradient(ellipse at 85% 100%, rgba(100, 50, 255, 0.4) 0%, rgba(100, 50, 255, 0) 50%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "white",
    fontFamily: "Inter, sans-serif",
  }),
}));

export const LandingBannerInner = styling("div")((props) => ({
  width: "100%",
  maxWidth: 1440,
  height: "auto",
  minHeight: "507px",
  padding: 100,
  justifyContent: "space-between",
  alignItems: "center",
  display: "inline-flex",
  gap: "40px",

  [props.theme.breakpoints.down("lg")]: {
    width: "100%",
    minHeight: "660px",
    height: "auto",
    padding: "40px 24px",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: 24,
  },

  [props.theme.breakpoints.down("tablet")]: {
    minHeight: "498px",
    padding: "20px 16px",
    gap: 24,
  },
}));

export const LandingBannerLeft = styling("div")((props) => ({
  minHeight: 507,
  flexDirection: "column",
  justifyContent: "space-between",
  alignItems: "flex-start",
  display: "inline-flex",
  flexShrink: 0,
  gap: "20px",
  width: "35%",

  [props.theme.breakpoints.down("lg")]: {
    minHeight: "auto",
    justifyContent: "flex-start",
    alignItems: "center",
    width: "100%",
  },

  [props.theme.breakpoints.down("tablet")]: {
    alignItems: "center",
  },
}));

export const LandingBannerPartnerContainer = styling("div")((props) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: "8px",
  padding: "12px 24px 12px 0",

  [props.theme.breakpoints.down("lg")]: {
    padding: "12px 10px 22px 0",
  },

  [props.theme.breakpoints.down("tablet")]: {
    padding: "8px 0",
  },
}));

export const LandingBannerPartnerLogo = styling("img")((props) => ({
  display: "flex",
  width: "40px",
  height: "40px",
  background: "white",
  borderRadius: "8px",
  border: "1px solid #F5F5F5",
  objectFit: "contain",
  justifyContent: "center",
  alignItems: "center",

  [props.theme.breakpoints.down("lg")]: {
    objectFit: "contain",
    display: "flex",
    width: "30px",
    height: "30px",
    justifyContent: "center",
    alignItems: "center",
  },
}));

export const LandingBannerPartnerName = styling("div")((props) => ({
  color: "white",
  fontSize: 16,
  fontWeight: 400,
  lineHeight: "24px",
  letterSpacing: "0.15px",
}));

export const LandingBannerTitleCard = styling("div")((props) => ({
  width: "100%",
  maxWidth: 364,
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  gap: 12,
  display: "flex",

  [props.theme.breakpoints.down("lg")]: {
    maxWidth: 548,
    alignItems: "flex-start",
    textAlign: "left",
  },

  [props.theme.breakpoints.down("tablet")]: {
    maxWidth: 292,
  },
}));

export const LandingBannerTitle = styling("h1")((props) => ({
  alignSelf: "stretch",
  color: "white",
  fontSize: 60,
  fontFamily: "Poppins",
  fontWeight: 700,
  lineHeight: "70px",

  [props.theme.breakpoints.down("lg")]: {
    fontSize: 40,
    lineHeight: "40px",
    textAlign: "left",
  },

  [props.theme.breakpoints.down("tablet")]: {
    fontSize: 20,
    fontFamily: "Inter",
    fontWeight: 700,
    lineHeight: "30px",
    textAlign: "left",
  },
}));

export const LandingBannerSubtitle = styling("div")((props) => ({
  maxWidth: "358px",
  color: "white",
  fontSize: 16,
  fontFamily: "Inter",
  fontWeight: 400,
  lineHeight: "24px",
  letterSpacing: 0.15,
  wordWrap: "break-word",

  [props.theme.breakpoints.down("lg")]: {
    maxWidth: "548px",
    fontSize: 14,
    lineHeight: "24px",
    letterSpacing: 0.15,
    textAlign: "left",
  },

  [props.theme.breakpoints.down("tablet")]: {
    maxWidth: "292px",
    fontSize: 14,
    lineHeight: "20px",
    letterSpacing: 0.11,
    textAlign: "left",
  },
}));

export const LandingBannerCta = styling("button")((props) => ({
  appearance: "none",
  border: "none",
  height: 48,
  paddingLeft: 24,
  paddingRight: 24,
  paddingTop: 11,
  paddingBottom: 11,
  background: Color.white,
  color: Color.hiredlyPurple,
  borderRadius: 40,
  justifyContent: "center",
  alignItems: "center",
  gap: 10,
  display: "inline-flex",
  cursor: "pointer",
  boxShadow: "0 4px 16px rgba(0, 0, 0, 0.25)",
  transition: "transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease",

  "&:hover": {
    background: "#F5F0FF",
    transform: "translateY(-1px)",
    boxShadow: "0 6px 20px rgba(0, 0, 0, 0.3)",
  },

  "&:active": {
    transform: "translateY(0)",
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.25)",
  },

  [props.theme.breakpoints.down("lg")]: {
    justifyContent: "center",
    alignItems: "center",
  },

  [props.theme.breakpoints.down("tablet")]: {
    height: 36,
    paddingLeft: 18,
    paddingRight: 18,
    maxWidth: "340px",
    width: "100%",
  },
}));

export const LandingBannerCtaText = styling("span")((props) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "#000",
  fontSize: 15,
  fontFamily: "Inter",
  fontWeight: 700,
  lineHeight: "23.81px",
  wordWrap: "break-word",

  [props.theme.breakpoints.down("tablet")]: {
    fontSize: 12,
    lineHeight: "16px",
    letterSpacing: 0.06,
  },
}));

export const LandingBannerCtaIcon = styling("div")((props) => ({
  width: 24,
  height: 24,
  position: "relative",
  overflow: "hidden",

  [props.theme.breakpoints.down("tablet")]: {
    width: 16,
    height: 16,
  },
}));

export const LandingBannerCtaIconBar = styling("div")((props) => ({
  width: 16.5,
  height: 15,
  left: 3.75,
  top: 4.5,
  position: "absolute",
  background: "white",

  [props.theme.breakpoints.down("tablet")]: {
    width: 11,
    height: 10,
    left: 2.5,
    top: 3,
  },
}));

export const LandingBannerRight = styling("div")((props) => ({
  flex: "1 1 0",
  minWidth: 0,
  padding: 12,
  background: "rgba(255, 255, 255, 0.10)",
  overflow: "visible",
  borderRadius: 28,
  justifyContent: "center",
  alignItems: "center",
  gap: 10,
  display: "flex",
  width: "65%",

  [props.theme.breakpoints.down("lg")]: {
    width: "100%",
    maxWidth: 548,
  },

  [props.theme.breakpoints.down("tablet")]: {
    width: "100%",
    maxWidth: 340,
    padding: 8,
    borderRadius: 24,
  },
}));

export const LandingBannerImage = styling("img")((props) => ({
  display: "block",
  width: "100%",
  height: "auto",

  ...(!props.$imageOnly && {
    maxHeight: 504,
    objectFit: "cover",
    objectPosition: "center",
    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
    borderRadius: 16,

    [props.theme.breakpoints.down("lg")]: {
      maxHeight: 322,
    },

    [props.theme.breakpoints.down("tablet")]: {
      maxHeight: 212,
    },
  }),
}));
